<script>
  import { createEventDispatcher } from 'svelte';
  import { inview } from 'svelte-inview';

  import Mixpanel from '@utils/mixpanel';

  import Avatar from '@components/Avatar.svelte';
  import AccountVerifiedIcon from '@app-components/AccountVerifiedIcon.svelte';

  export let mobile = false;
  export let loading = false;
  export let hasMore = false;

  export let searchTerm = '';
  export let searchResults = [];
  export let selectedIndex = -1;

  export let keywordSearch = true;
  export let userSearch = true;

  export let goToUser;
  export let goToKeyword;
  export let offset = 1;

  const dispatch = createEventDispatcher();

  const trackMixpanel = function (data) {
    Mixpanel.track('Search Prefill Click', data);
  };

  // const highlightText = function (elem, data) {
  //   if (elem && data) {
  //     try {
  //       let text = jQuery(elem).text();
  //       let re = new RegExp(`(${data})`, 'ig');

  //       if (text.match(re)) {
  //         jQuery(elem).html(text.replace(re, `<span class='global-search-highlight'>$1</span>`));
  //       }
  //     } catch (err) {}
  //   }
  // };
</script>

<style style="text/scss" lang="scss">
  @import '../../vendor/design-system.scss';

  .flex-item {
    display: flex;
  }

  .recently-viewed-label {
    color: var(--neutral-gray, #7f7f7f);
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px; /* 142.857% */
    margin-top: 12px;
    padding-left: 16px;
    &.mobile {
      padding-left: 20px;
    }
  }

  .search-results.desktop {
    position: absolute;
    z-index: 99;
    background-color: #fff;
    width: inherit;
    overflow-y: scroll;
    height: 350px;
    box-shadow: 0px 22px 100px 0px rgba(0, 0, 0, 0.1);
    border-bottom-right-radius: 15px;
    border-bottom-left-radius: 15px;
  }

  .search-results {
    display: flex;
    flex-direction: column;
    padding: 0px;
    gap: 0px;
    margin-top: 0px;

    .select-selected {
      background: #f9f7ff;
      cursor: pointer;
    }

    .search-result {
      display: flex;
      flex-direction: row;
      gap: 12px;
      padding-left: 16px;
      padding-right: 16px;
      padding-top: 10px;
      padding-bottom: 10px;

      &.mobile {
        padding-left: 20px;
        padding-right: 20px;
      }

      &.first {
        padding-top: 16px;
      }

      .user-info {
        flex-direction: column;
        margin-left: 4px;
        vertical-align: middle;
        justify-content: center;
        margin-right: 30px;

        .name {
          cursor: pointer;
          @include typeface-h6($font-weight-medium);
          line-height: 20px;
          height: 20px;
          color: $neutral-black;
        }

        .username {
          @include typeface-h6($font-weight-regular);
          color: $neutral-gray;
        }
      }
    }
  }

  :global(.global-search-highlight) {
    background-color: #e5e1f4;
    padding-top: 3px;
    padding-bottom: 4px;
    padding: 1px;
    border-radius: 4px;
    font-weight: bold;
  }
</style>

{#if mobile && searchTerm == ''}
  <div class="recently-viewed-label mobile">Recently viewed</div>
{/if}
<div class="search-results {mobile ? 'mobile' : 'desktop purple-scrollbar-rounded-light-wide-rounded'}">
  {#if loading && offset == 1}
    <div></div>
  {:else}
    {#if !mobile && searchTerm == ''}
      <div class="recently-viewed-label desktop">Recently viewed</div>
    {/if}
    {#each searchResults as result, index}
      {#if result.id}
        <div
          on:mouseover={() => (selectedIndex = index)}
          on:mouseout={() => (selectedIndex = -1)}
          class:select-selected={selectedIndex == index}>
          <div class="search-result {index == 0 ? 'first' : ''} {mobile ? 'mobile' : 'desktop'}">
            <div
              class="avatar-wrapper"
              on:click|preventDefault|stopPropagation={(e) => {
                trackMixpanel({ 'User ID': result.id });
                if (!result.spotlight_active) {
                  goToUser(result, e);
                }
              }}>
              <Avatar
                width={40}
                height={40}
                src={result.avatar_url}
                href={result.profile_path}
                mobile={mobile}
                user={result} />
            </div>
            <div
              class="flex-item user-info"
              on:click|preventDefault|stopPropagation={(e) => {
                trackMixpanel({ 'User ID': result.id });
                goToUser(result, e);
              }}>
              <span class="name">
                <AccountVerifiedIcon
                  dimension={16}
                  verified={result.verified}
                  on:areaClicked={(e) => {
                    goToUser(result, e.detail.event);
                  }}>
                  <svelte:fragment slot="account-name">
                    <span
                      style="display: -webkit-box; -webkit-line-clamp: 1; -webkit-box-orient: vertical; text-overflow: ellipsis; overflow: hidden;">
                      {result.name}
                    </span></svelte:fragment>
                </AccountVerifiedIcon>
              </span>
              {#if result.username}
                <span
                  class="username"
                  style="display: -webkit-box; -webkit-line-clamp: 1; -webkit-box-orient: vertical; text-overflow: ellipsis; overflow: hidden;">
                  {result.username}
                </span>
              {/if}
            </div>
          </div>
        </div>
      {:else}
        <a
          on:mouseover={() => (selectedIndex = index)}
          on:mouseout={() => (selectedIndex = -1)}
          class:select-selected={selectedIndex == index}
          on:click|preventDefault|stopPropagation={(e) => {
            trackMixpanel({ 'Search Value': result });
            goToKeyword(result, e);
          }}
          href="/search?keyword={result}">
          <div class="search-result {index == 0 ? 'first' : ''} {mobile ? 'mobile' : 'desktop'}">
            <div
              class="avatar-wrapper"
              style="width: 40px; height: 30px; display: flex; align-items: center; justify-content: center;">
              <img src="/images/search-icon.svg" />
            </div>
            <div class="flex-item user-info">
              <span class="name">
                <AccountVerifiedIcon dimension={16} verified={result.verified}>
                  <svelte:fragment slot="account-name">
                    <span
                      style="font-weight: 400"
                      on:click={(e) => {
                        goToKeyword(result, e);
                      }}>{result}</span>
                  </svelte:fragment>
                </AccountVerifiedIcon>
              </span>
            </div>
          </div>
        </a>
      {/if}
    {/each}

    {#if !loading && searchResults.length < 1 && searchTerm != ''}
      <div style="margin-top: 30px; color: #1a1a1a; opacity: 0.5; text-align: center;">
        {#if keywordSearch}
          No results
        {:else if userSearch}
          No results! Try searching for a different user.
        {/if}
      </div>
    {/if}

    {#if hasMore && searchTerm != ''}
      <div use:inview={{}} on:enter={() => dispatch('load-data')} />
    {/if}
  {/if}
</div>
